import { ColumnState } from 'ag-grid-community'

import { baseApi } from '@/services'

export type WorkQueuesPreset = {
  user_id?: number
  id?: string
  uuid?: string
  user: number
  name?: string
  search?: string
  stage?: string
  subscribers?: string
  view_all?: boolean
  column_state: ColumnState[]
  filter_model: object
  company_preset?: boolean
}

export const workQueuesPresetsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listWorkQueuesPresets: builder.query<WorkQueuesPreset[], number | void>({
      query: (user) => {
        return { url: 'v2/work-queues-presets/', params: user ? { user } : {} }
      },
      providesTags: () => ['WorkQueuesPresets'],
    }),
    createWorkQueuesPreset: builder.mutation<WorkQueuesPreset, Partial<WorkQueuesPreset>>({
      query: (payload) => ({
        method: 'POST',
        url: 'v2/work-queues-presets/',
        body: payload,
      }),
      invalidatesTags: ['WorkQueuesPresets'],
    }),
    updateWorkQueuesPreset: builder.mutation<WorkQueuesPreset, Partial<WorkQueuesPreset>>({
      query: (payload) => ({
        method: 'PATCH',
        url: `v2/work-queues-presets/${payload.uuid}/`,
        body: payload,
      }),
      invalidatesTags: ['WorkQueuesPresets'],
    }),
    deleteWorkQueuesPreset: builder.mutation<void, string>({
      query: (uuid) => ({
        method: 'DELETE',
        url: `v2/work-queues-presets/${uuid}/`,
      }),
      invalidatesTags: ['WorkQueuesPresets'],
    }),
  }),
})

export const {
  useListWorkQueuesPresetsQuery,
  useCreateWorkQueuesPresetMutation,
  useUpdateWorkQueuesPresetMutation,
  useDeleteWorkQueuesPresetMutation,
} = workQueuesPresetsApi
